<template>
  <div class="container">
    <h2>{{ $t('titre.RefExpense') }}</h2>

    <!-- Form Section -->
    <div class="mb-2">
      <form @submit.prevent="saveExpense" class="row g-3 align-items-center justify-content-between">
        <div class="form-group row mt-2">
          <label for="inputCode" class="col-sm-2 text-start col-form-label">{{ $t('code') }}</label>
          <div class="col-sm-2">
            <input id="inputCode" v-model="formData.code" class="form-control" :placeholder="$t('input_code')"
              required />
          </div>
          <label for="inputValue" class="col-sm-2 text-start col-form-label">{{ $t('value') }}</label>
          <div class="col-sm-6">
            <input id="inputValue" v-model="formData.value" class="form-control shadow-sm"
              :placeholder="$t('input_value')" required />
          </div>
        </div>
        <div class="btn-update-cancel">
          <button class="btn btn-outline-success btn-sm me-2 btn-lg w-80">
            <i class="fas fa-save"></i> {{ formData.id ? $t('update') : $t('add') }}
          </button>
          <button class="btn btn-outline-danger btn-sm me-2 btn-lg w-80" type="reset">
            <i class="bi bi-x"></i> {{ $t('cancel') }}
          </button>
        </div>
      </form>
    </div>

    <!-- Filterable Table Section -->
    <div class="card mt-3">
      <table class="custom-table">
        <thead>
          <!-- Filter Row -->
          <tr>
            <th>
              <input v-model="filters.code" placeholder="Filter Code" @input="applyFilters" class="filter-input" />
            </th>
            <th>
              <input v-model="filters.value" placeholder="Filter Value" @input="applyFilters" class="filter-input" />
            </th>
            <th>Actions</th>
          </tr>
          <!-- Header Row -->
          <tr>
            <th>{{ $t('code') }}</th>
            <th>{{ $t('value') }}</th>
            <th>{{ $t('actions') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in filteredItems" :key="index">
            <td class="col-md-2">{{ item.code }}</td>
            <td class="col-md-8">{{ item.value }}</td>
            <td class="col-md-2">
              <div class="btn-edit-delete">
                <button class="btn btn-outline-primary btn-sm me-2" @click="editExpense(item)">
                  <i class="fas fa-edit"></i> <!--{{ $t('edit') }}-->
                </button>
                <button class="btn btn-outline-danger btn-sm" @click="deleteExpense(item.id)">
                  <i class="fas fa-trash"></i> <!--{{ $t('delete') }}-->
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { ExpenseService } from '../api';
import { Message } from "../libjs/alertService"; // Adjust the path

export default {
  data() {
    return {
      expenses: [], // All expenses fetched from the server
      filters: {
        code: "",
        value: "",
      },
      formData: {
        id: null,
        code: "",
        value: "",
      },
    };
  },
  computed: {
    filteredItems() {
      return this.expenses.filter((item) => {
        return (
          (this.filters.code === "" || item.code.includes(this.filters.code)) &&
          (this.filters.value === "" || item.value.toLowerCase().includes(this.filters.value.toLowerCase()))
        );
      });
    },
    isRtleft() {
      return this.$i18n.locale === "ar"; // Adjust based on your setup
    },
  },
  methods: {
    async fetchExpenses() {
      try {
        const response = await ExpenseService.listExpense();
        this.expenses = response;
      } catch (error) {
        console.error("Error fetching expenses:", error);
      }
    },
    async saveExpense() {
      try {
        if (this.formData.id) {
          await ExpenseService.updateExpense(this.formData.id, this.formData);
          Message("success", this.$t("message.update_success"));
        } else {
          await ExpenseService.createExpense(this.formData);
          Message("success", this.$t("message.add_success"));
        }
        this.resetForm();
        this.fetchExpenses();
      } catch (error) {
        Message("danger", this.$t("message.operation_failed"));
      }
    },
    async deleteExpense(id) {
      try {
        await ExpenseService.deleteExpense(id);
        this.fetchExpenses();
        Message("success", this.$t("message.delete_success"));
      } catch (error) {
        Message("danger", this.$t("message.delete_failed"));
      }
    },
    editExpense(expense) {
      this.formData = { ...expense };
    },
    resetForm() {
      this.formData = {
        id: null,
        code: "",
        value: "",
      };
    },
    applyFilters() {
      // Filters are automatically applied by computed property `filteredItems` based on `filters.code` and `filters.value`.
    },
  },
  mounted() {
    this.fetchExpenses();
  },
};
</script>


<style scoped>
.container {
  margin-top: 20px;
  border: 1px solid #ddd;
  padding: 0px;
  border-radius: 10px;
}

h2 {
  background-color: #47c399;
  border-radius: 10px 10px 0 0;
  color: azure;
  padding: 3px;
  text-align: justify;
  padding-left: 15px;
}

/* Shared Styles */
body,
input,
button {
  font-family: "Arial", sans-serif;
  font-size: 14px;
}

/* Form Styles */
form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 15px;
  margin: 1px;
}

form input {
  flex: 1;
  padding: 6px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

form button {
  padding: 6px 12px;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
}

form button[type="submit"] {
  background-color: #28a745;
  color: #fff;
}

form button[type="submit"]:hover {
  background-color: #218838;
}

/* Table Styles */
.custom-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.custom-table thead tr {
  background-color: #f2f2f2;
}

.custom-table th,
.custom-table td {
  border: 1px solid #ddd;
  padding: 6px;
  text-align: center;
}

.custom-table tbody tr:nth-child(even) {
  background-color: #fafafa;
}

.custom-table tbody tr:hover {
  background-color: #f1f1f1;
}

/* Filter Input Styling */
.filter-input {
  width: 100%;
  padding: 6px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

/* Button Styles */
.edit-btn,
.delete-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 3px;
  font-size: 14px;
  cursor: pointer;
}

.edit-btn {
  background-color: #007bff;
  color: white;
  margin-right: 5px;
}

.edit-btn:hover {
  background-color: #0056b3;
}

.delete-btn {
  background-color: #dc3545;
  color: white;
}

.delete-btn:hover {
  background-color: #c82333;
}

form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

form .ms-auto {
  margin-left: auto;
}

.custom-header {
  text-align: left;
  /* Aligns text to the left */
}
</style>
